<span class="ad-status-badge" [class]="'ad-status-badge ' + statusClass">{{ statusLabel }}</span>
